import { useState } from 'react';

/**
 * 商品圖片顯示元件，相容兩種來源：
 *   - URL 字串（http(s):// 或 / 開頭）→ 用 <img> 顯示真實圖片
 *   - SVG symbol id（如 "dart-full"）→ 沿用 <use href="#id">（舊 mock 資料 / 預設圖）
 *
 * 保底：img 一律 maxWidth/maxHeight 100% + objectFit contain，確保不會撐破容器；
 *       圖片載入失敗時 fallback 成預設 svg 圖示，避免破圖佔位撐出框外。
 *
 * 之後接圖片上傳後，images[] 會全部是 URL，這個元件不用改。
 */
function isUrl(v) {
  return typeof v === 'string' && (v.startsWith('http://') || v.startsWith('https://') || v.startsWith('/'));
}

function ProductImage({ src, alt = '', className, svgStyle, imgStyle, fallback = 'dart-full' }) {
  const [errored, setErrored] = useState(false);
  const value = src || fallback;

  if (isUrl(value) && !errored) {
    return (
      <img
        src={value}
        alt={alt}
        className={className}
        loading="lazy"
        onError={() => setErrored(true)}
        // 保底樣式在前，imgStyle 可覆寫，但 maxWidth/maxHeight 確保不爆框
        style={{
          display: 'block',
          objectFit: 'contain',
          ...imgStyle,
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    );
  }

  // 非 URL，或圖片載入失敗 → 顯示預設 svg 圖示
  return (
    <svg viewBox="0 0 200 600" className={className}
      style={{ maxWidth: '100%', maxHeight: '100%', ...svgStyle }}>
      <use href={`#${errored ? fallback : value}`} />
    </svg>
  );
}

export { isUrl };
export default ProductImage;
